// import store from '@/stores';

const name = 'worker-credit';
const path = '/clt';

// B2B-185: fila de leads de leilão — restrita ao Master/Admin da promotora.
// Confirmar com backend/produto os role_ids exatos de "Admin" da promotora
// (hoje usa admin(1)/master(18)/managerMaster(23), ver isPromotoraMasterOrAdmin).
// const AUCTION_LEADS_ALLOWED_ROLES = [1, 18, 23];

export default [
  // routes
  {
    name: `${name}-proposal`,
    path: `${path}/propostas`,
    component: () => import('@/views/workerCredit/WorkerCreditList.vue'),
  },
  {
    name: `${name}-proposal-action`,
    path: `${path}/leilao`,
    component: () => import('@/views/workerCredit/action/ListView.vue'),
  },
  {
    name: `${name}-auction-leads`,
    path: `${path}/leilao/leads`,
    component: () => import('@/views/workerCredit/AuctionLeadsList.vue'),
  },
  {
    name: `${name}-consult`,
    path: `${path}/consultar`,
    component: () => import('@/views/workerCredit/WorkerCreditConsult.vue'),
  },
  {
    name: `${name}-new`,
    path: `${path}/novo`,
    component: () => import('@/views/workerCredit/WorkerCreditNewProposal.vue'),
  },
  {
    name: `${name}-contract-management`,
    path: `${path}/contratos`,
    component: () => import('@/views/workerCredit/WorkerCreditContractManagement.vue'),
  },
  {
    name: `${name}-contract-management-details`,
    path: `${path}/detalhes-do-contrato/:proposal_id/:communication_id?`,
    component: () => import('@/views/workerCredit/WorkerCreditContractManagementDetails.vue'),
  },
  {
    name: `${name}-contract-management-companies`,
    path: `${path}/contratos/listagem-empresas`,
    component: () => import('@/views/workerCredit/WorkerCreditListCompany.vue'),
  },
  {
    name: `${name}-contract-debt-collection`,
    path: `${path}/contratos/gestao-cobranca`,
    component: () => import('@/views/workerCredit/WorkerCreditContractDebtCollection.vue'),
  },
  {
    name: `${name}-contract-debt-collection-details`,
    path: `${path}/contratos/gestao-cobranca/:id`,
    component: () => import('@/views/workerCredit/WorkerCreditContractDebtCollectionDetails.vue'),
  },

  // redirects (legacy)
  {
    path: '/propostas/consignado-privado',
    redirect: `${path}/propostas`,
  },
  {
    path: '/cpr/propostas',
    redirect: `${path}/propostas`,
  },
  {
    path: '/cpr/consultar',
    redirect: `${path}/consultar`,
  },
  {
    path: '/cpr/novo',
    redirect: `${path}/novo`,
  },
  {
    path: '/credito-trabalhador/propostas',
    redirect: `${path}/propostas`,
  },
  {
    path: '/credito-trabalhador/consultar',
    redirect: `${path}/consultar`,
  },
  {
    path: '/credito-trabalhador/novo',
    redirect: `${path}/novo`,
  },
];
